import { Dialog, DialogContent } from "@/shared/components/ui/dialog";
import { X, Download } from "lucide-react";
import { Button } from "@/shared/components/ui/button";

interface ImageModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  imageUrl: string;
  imageName: string;
}

export function ImageModal({ open, onOpenChange, imageUrl, imageName }: ImageModalProps) {
  const handleDownload = () => {
    // Create a temporary anchor element to trigger download
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = imageName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh] p-0 overflow-hidden">
        {/* Header with close and download buttons */}
        <div className="absolute top-4 right-4 z-50 flex gap-2">
          <Button
            variant="secondary"
            size="icon"
            onClick={handleDownload}
            className="h-10 w-10 rounded-full bg-white/90 hover:bg-white shadow-lg"
          >
            <Download className="h-5 w-5" />
          </Button>
          <Button
            variant="secondary"
            size="icon"
            onClick={() => onOpenChange(false)}
            className="h-10 w-10 rounded-full bg-white/90 hover:bg-white shadow-lg"
          >
            <X className="h-5 w-5" />
          </Button>
        </div>

        {/* Image container */}
        <div className="flex items-center justify-center bg-black/95 min-h-[60vh] max-h-[90vh]">
          <img
            src={imageUrl}
            alt={imageName}
            className="max-w-full max-h-[90vh] object-contain"
          />
        </div>

        {/* Footer with image name */}
        <div className="absolute bottom-0 left-0 right-0 bg-white/95 px-6 py-3 border-t">
          <p className="text-sm text-gray-700 font-medium truncate">{imageName}</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
